import React, { type ReactElement } from 'react';
import { skBlack } from 'src/constants/styles';

const MatchIcon = (): ReactElement => (
  <svg width="16px" height="15px" viewBox="0 0 14 11">
    <title>Role requirements match Icon</title>
    <path
      fill="none"
      fillRule="evenodd"
      stroke={skBlack}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M87.4851064 189L79.5778116 198 76.4148936 194.4"
      transform="translate(-455 -488) translate(380 300)"
    />
  </svg>
);

export default MatchIcon;
